import { render, staticRenderFns } from "./PlaceholderComponent.vue?vue&type=template&id=4bd536bc&scoped=true"
import script from "./PlaceholderComponent.vue?vue&type=script&lang=js"
export * from "./PlaceholderComponent.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderComponent.vue?vue&type=style&index=0&id=4bd536bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd536bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd536bc')) {
      api.createRecord('4bd536bc', component.options)
    } else {
      api.reload('4bd536bc', component.options)
    }
    module.hot.accept("./PlaceholderComponent.vue?vue&type=template&id=4bd536bc&scoped=true", function () {
      api.rerender('4bd536bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/PlaceholderComponent.vue"
export default component.exports